/* Probably Late — cookie notice.
   Remembers the choice locally and, when Shopify's Customer Privacy API is
   present, records real consent through it so tracking follows the answer. */
(function () {
  var KEY = 'pl-cookie-choice';
  var box = document.querySelector('[data-pl-cookies]');
  if (!box) return;

  var stored = null;
  try {
    stored = localStorage.getItem(KEY);
  } catch (e) {}
  if (stored) return; // already answered — stay hidden

  box.hidden = false;
  // let the initial style settle so the entrance transition runs; a timer
  // rather than rAF, which is frozen while the tab sits in the background
  setTimeout(function () {
    box.classList.add('is-in');
  }, 60);

  function remember(choice) {
    try {
      localStorage.setItem(KEY, choice);
    } catch (e) {}

    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.setTrackingConsent === 'function') {
      api.setTrackingConsent(choice === 'accept', function () {});
    }

    box.classList.remove('is-in');
    setTimeout(function () {
      box.hidden = true;
    }, 500);
  }

  var accept = box.querySelector('[data-pl-cookies-accept]');
  var decline = box.querySelector('[data-pl-cookies-decline]');
  if (accept) accept.addEventListener('click', function () { remember('accept'); });
  if (decline) decline.addEventListener('click', function () { remember('decline'); });
})();

